import axios from 'axios'
import { useSiteConfig } from '../components/layout/getSiteConfig'

export function usePostError() {
  const { useTest } = useSiteConfig()

  return async (error) => {
    const errorMessages = error?.response?.data?.error?.messages
    const message = errorMessages ? errorMessages[0].description : (error?.message ?? 'Server error')
    if (!useTest) {
      await axios.post('https://mcntags.com/api/log-error', { clientError: message })
    }
    
    alert(message)
  }
}